export default __webpack_public_path__ + "static/media/Waschbär.7f723ac3.png";